import { SidebarProvider } from '@src/app/layout';
import { Box } from '@src/shared/ui/layout';

import Main from './Main';
import { MainProvider } from './MainContext';
import Sidebar from './Sidebar';

function Navigation() {
  return (
    <Box component="nav">
      <Sidebar />
    </Box>
  );
}

export default function App() {
  return (
    <MainProvider>
      <SidebarProvider>
        <Navigation />
        <Main />
      </SidebarProvider>
    </MainProvider>
  );
}
